import React, { useEffect, useRef, useState } from "react";
import { FaTrash, FaUpload } from "react-icons/fa";
import api from "../../utils/api";

const ImageUploadPreview = ({
  initialImages = [],
  overAllUploads = [],
  onChange = null,
  onChange2 = null,
}) => {
  const [uploads, setUploads] = useState(overAllUploads);
  const [images, setImages] = useState(initialImages); // selected images for this component
  const inputRef = useRef();

  useEffect(() => {
    setImages(initialImages);
  }, [initialImages]);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    const formData = new FormData();
    files.forEach((file) => formData.append("images[]", file));

    try {
      const res = await api.post(
        "restaurant/restaurant/menu/upload-images",
        formData
      );
      const uploaded = res.data.uploads; // assuming 'paths' contains full URLs
      const updated = [...images, ...uploaded];
      // setUploads((prev) => [...prev, ...uploaded]);
      setImages(updated);
      const flattened = updated.map((img) => img.image);
      if (onChange) {
        onChange(flattened);
      }
      if (onChange2) {
        onChange2(updated);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  const handleRemove = (name) => {
    const updated = images.filter((img) => img.image !== name);
    setImages(updated);
    const flattened = updated.map((img) => img.image);
    if (onChange) {
      onChange(flattened);
    }
    if (onChange2) {
      onChange2(updated);
    }
  };
  

  return (
    <div className="space-y-3">
      {/* Upload Button */}
      <div>
        <button
          type="button"
          onClick={() => inputRef.current.click()}
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          <FaUpload />
          Upload Images
        </button>
        <input
          type="file"
          multiple
          accept="image/*"
          ref={inputRef}
          onChange={handleUpload}
          className="hidden"
        />
      </div>

      {/* Selected Image Preview Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {images.map((img, index) => (
          <div
            key={index}
            className="relative group overflow-hidden rounded-lg border shadow hover:shadow-lg transition-all"
          >
            <img
              src={img.path}
              alt={`selected-${index}`}
              className="w-full h-32 object-cover"
            />

            {/* Delete icon (only removes from this selection, not all images globally) */}
            <button
              type="button"
              onClick={() => handleRemove(img.image)}
              className="absolute top-1 right-1 bg-black bg-opacity-60 text-white p-1 rounded-full transition"
              title="Remove from selected images"
            >
              <FaTrash size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUploadPreview;
